import { gql } from '__generated__';

gql(`
  fragment EventFields on Event {
    id
    title
    location {
      id
      title
      description
    }
    checkout_url
    website_url
    email
    brand_color
    logo {
      id
      url
    }
    header {
      id
      file {
        id
        url
      }
    }
    start_date
    end_date
    ticket_numbers_published
    private_teams
    enable_tickets
    tickets_available
    tickets_available_from
    payment_methods
    require_company_for_bank_transfer
    enable_fundraising
    require_fundraising
    allow_other_charity
    supporta_url
    ticket_categories {
      id
      sport_type
    }
    charities {
      id
      title
      logo_url
      description
    }
    enable_public_resale
    public_resale_start_date
    public_resale_end_date
    enable_private_resale
    private_resale_start_date
    private_resale_end_date
    resale_url
    active
    mail_permissions {
      id
      label
      title
      soft_opt_in
    }
  }
`);

gql(`
  fragment BasicRegistrationFields on Registration {
    id
    qr_url
    qr_code
    ticket_url
    sequence
    complete
    ticket_complete
    upgrades_complete
    ticket_number
    invited_email
    assigned
    locked
    has_upgrades_available
    full_name
    exchange_code
    is_reassignable
    status
    waitlist_position
    waitlist_paused
    waitlist_invite {
      id
      pending_invite {
        id
        expires_at
        total_amount
      }
    }
    resale {
      id
      public
      resellable
      available
      has_pending_waitlist_invitation
    }
    preregistration {
      id
      lottery_status
      draw_result {
        id
        amount
        end_date
      }
    }
    preregistered_by {
      id
    }
    is_unassignable
    participant {
      id
      email
    }
    owner {
      id
    }
    purchase {
      unit_id
      batch_size
    }
    ticket {
      id
      title
      preregistration
      allow_resale
    }
    promotion {
      id
      title
    }
    time_slot {
      id
      start_date
      start_time
      title
      multi_date
    }
    team {
      id
      title
    }
    upgrades {
      id
      complete
      product {
        id
        title
        type
      }
      promotion {
        id
        title
      }
      product_variant {
        id
        title
      }
    }
  }
`);

export default gql(`
  query GetRegistrationSummaryForDashboard($participant: ID!, $event: ID!, $token: String, $registrations_limit: Int, $registration_filters: RegistrationFilters, $preregistrations_limit: Int, $waitlist_registrations_limit: Int, $teams_search: String, $teams_ids: [String!], $teams_limit: Int, $include_filtered_teams: Boolean!) {
    registrationSummary(participant: $participant, event: $event, token: $token) {
      id
      event {
        ...EventFields
      }
      view_token
      participant {
        id
        email
        full_name
        first_name
        last_name
      }
      orders {
        id
        invoice_id
        invoice_amount
        remaining_amount
        invoice_date
        due_date
      }
      has_upgrades_available
      orders_count
      registrations_count
      filtered_registrations_count: registrations_count(filters: $registration_filters)
      registrations: registrations(filters: $registration_filters, limit: $registrations_limit) {
        ...BasicRegistrationFields
      }
      preregistrations_count
      preregistrations(limit: $preregistrations_limit) {
        ...BasicRegistrationFields
      }
      waitlist_registrations_count
      waitlist_registrations(limit: $waitlist_registrations_limit) {
        ...BasicRegistrationFields
      }
      assigned_ticket_counts {
        id
        ticket {
          id
          title
        }
        promotion {
          id
        }
        assigned_count
        assignable_count
        invited_count
        total_count
      }
      teams {
        id
        title
      }
      teams_count
      filtered_teams: teams(search: $teams_search, ids: $teams_ids, limit: $teams_limit) @include (if: $include_filtered_teams) {
        id
        title
      }
      filtered_teams_count: teams_count(search: $teams_search)
      is_company
      event_participant {
        id
        charity {
          id
          title
          logo_url
          description
        }
        enable_company_fundraising_campaign
      }
      claim_url
      export_participants_url
      tickets_url
      sent_messages {
        id
        sent_at
        message {
          id
          subject
          parsed_content(participant_id: $participant)
        }
      }
    }
  }
`);
